<template>
  <div class="animated fadeIn">
    <ShipOrderDialog EntityType="Order">
      <div slot="header">
        <h2>Test</h2>
      </div>
      <div slot="details">
        <!-- <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div> -->
      </div>
      <span slot="entityType">Sponsor</span>
    </ShipOrderDialog>
    <b-row>
      <b-col lg="6">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          name="radiosBtn"
          v-model="title1"
        >
          <b-form-radio
            class="mx-0 extraLongStandardizedRadioWidth"
            value="shippingsummary"
            >SHIPPING SUMMARY</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col lg="6">
        <b-form-group>
          <CoolSelect
            v-model="myCurrentMonth"
            class="form-input dropdown-content"
            placeholder="Month"
            theme="bootstrap"
            tooltip="Months"
            :items="shipping.active_months"
            item-text="Description"
            item-value="ShippingMonthID"
            id="ShippingMonthID"
            @select="changeMonth()"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text>Month</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-table
          :items="shipMethodReportLines"
          :fields="fields"
          hover
          small
          fixed
          striped
          caption
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
          <template slot="bottom-row" slot-scope="data">
            <td>
              <span class="fa-narbar mybold">Totals</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{ SUMS[0] }}</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{ SUMS[1] }}</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{ SUMS[3] }}</span>
            </td>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="20"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          name="radiosBtn"
          v-model="title2"
        >
          <b-form-radio
            class="mx-0 extraLongStandardizedRadioWidth"
            value="statussummary"
            >SHIPPING STATUS</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="SetStatusFilter"
          :items="shipStatusReportLines"
          :fields="fields2"
          hover
          small
          fixed
          striped
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="bottom-row" slot-scope="data">
            <td>
              <span class="fa-narbar mybold">Totals</span>
            </td>

            <td>
              <span class="fa-narbar mybold">{{ SUMS[0] }}</span>
            </td>
            <td>
              <span class="fa-narbar mybold"></span>
            </td>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="20"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <b-row class="primary-row divider-row">
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              class="divider-input"
              type="text"
              placeholder="Search"
              @keyup="searchWait"
              v-model.lazy="searchString"
            />

            <b-input-group-append>
              <b-input-group-text class="divider-input">
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <span class="divider-input pt-1"
              >There are {{ filteredRowCount() }} shipments that match
              {{ FilterTitle }}
            </span>
            <i
              v-b-tooltip
              v-if="
                isSubSet &&
                  this.filteredRowCount() > 0 &&
                  this.downloadFileName == ''
              "
              title="Download"
              style="cursor: pointer;"
              class="cui-cloud-download icons font-xl d-block ml-2 mt-3"
              @click="downloadSubSet"
            />
            <span class="divider-input pt-1 pl-3">
              <a
                v-if="
                  isSubSet &&
                    this.filteredRowCount() > 0 &&
                    this.downloadFileName != ''
                "
                :href="downloadFileLink"
                target="_blank"
              >
                File Ready
              </a>
            </span>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredShippingOrders"
          :fields="fieldsGrid"
          hover
          small
          fixed
          striped
          caption
          select-mode="single"
          responsive="sm"
          selectable
          selectedVariant="success"
          :current-page="currentPage2"
          :per-page="perPage2"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNav2Visible">
          <b-pagination
            :per-page="perPage2"
            :total-rows="filteredShippingOrdersRowCount"
            v-model="currentPage2"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>

    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          name="radiosBtn"
          v-model="title2"
        >
          <b-form-radio
            class="mx-0 extraLongStandardizedRadioWidth"
            value="statussummary"
            >DATE SUMMARY</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          :items="shipByDateReportLines"
          :fields="fields3"
          hover
          small
          fixed
          striped
          caption
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
          <template slot="bottom-row" slot-scope="data">
            <td>
              <span class="fa-narbar mybold">Totals</span>
            </td>

            <td>
              <span class="fa-narbar mybold">{{ SUMS3[0] }}</span>
            </td>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="30"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CoolSelect } from "vue-cool-select";
import { mapState, mapActions, mapGetters } from "vuex";
import cTable from "@/views/base/Table.vue";
import ShipOrderDialog from "@/views/shipping/ShippingOrderModal.vue";

export default {
  name: "Deliveries",
  data: () => {
    return {
      FilterTitle: "this search criteria",
      title1: "shippingsummary",
      title2: "statussummary",
      isReport1Visibile: true,
      fields: [
        {
          key: "ShipMethod",
          label: "Method",
          sortable: true
        },
        {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "Delivered",
          label: "Delivered",
          sortable: true
        },
        {
          key: "MyPercentage",
          label: "Percentage",
          sortable: true
        }
      ],
      fields2: [
        {
          key: "StatusDescription",
          label: "Description",
          sortable: true
        },
        {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "MyPercentage",
          label: "Percentage",
          sortable: true
        }
      ],
      fields3: [
        {
          key: "DateShipped",
          label: "Ship Date",
          sortable: true
        },
        {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        }
      ],
      fieldsGrid: [
        {
          key: "PONumber",
          label: "OrderID",
          sortable: true
        },
        {
          key: "CapGroup",
          label: "Group",
          sortable: true
        },
        {
          key: "FulfillmentType",
          label: "Type",
          sortable: true
        },
        {
          key: "ShipCompany",
          label: "Company",
          sortable: true
        },
        {
          key: "ShipName",
          label: "Name",
          sortable: true
        }
      ],
      mySelected: {},
      mySelected2: {},
      currentPage: 1,
      perPage: 50,
      shipMethodReportLines: [],
      shipStatusReportLines: [],
      shipByDateReportLines: [],
      SUMS: [0, 0, 0, 0],
      SUMS2: [0, 0, 0, 0],
      SUMS3: [0],
      timer: null,
      myCurrentMonth: {},
      searchString: "",
      filteredShippingOrders: [],
      downloadFileName: "",
      downloadFilePath: "https://api.icap-maker.com/Output/",
      isSubSet: false,
      perPage2: 50,
      currentPage2: 1,
      FilteredPOStringArray: []
    };
  },
  props: {},
  components: {
    cTable,
    CoolSelect,
    ShipOrderDialog
  },
  created() {
    this.$store
      .dispatch(
        "shipping/loadDeliveryReportLineItems",
        this.$store.state.shipping.active_month.ShippingMonthID
      )
      .then(() => {
        this.filterList();
      });
    this.$store
      .dispatch(
        "shipping/loadDeliveryStatusReportLineItems",
        this.$store.state.shipping.active_month.ShippingMonthID
      )
      .then(() => {
        this.filterList2();
      });
    this.$store
      .dispatch(
        "shipping/loadDeliveryByDateReportLineItems",
        this.$store.state.shipping.active_month.ShippingMonthID
      )
      .then(() => {
        this.filterList3();
      });

    this.$store
      .dispatch(
        "shipping/get_orders",
        this.$store.state.shipping.active_month.ShippingMonthID
      )
      .then(() => {
        //this.filterListOrders();
      });

    this.$store.dispatch("shipping/shippingMonths").then(() => {
      this.myCurrentMonth = this.$store.state.shipping.active_months.find(
        month => month.IsCurrent === true
      );
    });
  },
  mounted() {},
  computed: {
    ...mapGetters({}),
    isNavVisible: function() {
      return false;
    },
    isNav2Visible: function() {
      //return this.totalRows2 > this.perPage2;
      return this.filteredShippingOrdersRowCount > this.perPage2;
    },
    filteredShippingOrdersRowCount: function() {
      return this.filteredShippingOrders.length;
    },
    downloadFileLink: function() {
      return this.downloadFilePath + this.downloadFileName;
    },
    ...mapState(["shipping", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    resetSearch: function() {
      this.searchString = "";
      this.isSubSet = false;
      this.downloadFileName = "";
      this.filterListOrders();
    },
    async downloadSubSet() {
      var _op = {
        MonthID: this.myCurrentMonth,
        MailGroup: this.subSetGroup,
        MailType: this.subSetType,
        MailFilter: this.subSetFilter
      };
      this.$store
        .dispatch("shipping/createDownloadFile", _op)
        .then(response => {
          this.downloadFileName =
            response.data["ShippingInformationDownloadResult"];
          console.log(this.downloadFileName);
        });
    },
    searchWait(event) {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.filterListOrders();
        this.FilterTitle = "this search criteria";
      }, 2000);
    },
    filteredRowCount: function() {
      return this.filteredShippingOrders.length;
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("shipping/loadShippingOrderEdit", record.PONumber)
        .then(() => {
          //this.$router.push({ name: "ShippingOrder" });
          this.$bvModal.show("modal-shiporder");
        });
    },
    toggleVisibility1: function() {},
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    async SetStatusFilter(object) {
      this.mySelected = object;
      var _hack_description = "";
      if (this.mySelected.StatusDescription !== "In Transit") {
        _hack_description = this.mySelected.StatusDescription;
      }
      //console.log(_hack_description);
      this.FilterTitle = this.mySelected.StatusDescription;
      var _op = {
        MonthID: this.myCurrentMonth,
        Status: _hack_description
      };
      await this.$store
        .dispatch("shipping/filterByStatus", _op)
        .then(response => {
          this.FilteredPOStringArray =
            response.data["FilterByDeliveryStatusResult"];
        });
      this.filterListOrdersSubset();
      //console.log(this.FilteredPOStringArray);

      // this.filteredShippingOrders.filter(_so =>
      //     response.data["FilterByDeliveryStatusResult"].includes(_so.PONumber)
      //   );
    },
    filterList: function() {
      this.shipMethodReportLines = this.$store.state.shipping.delivery_report_line_items;
      for (var i = 0; i < this.shipMethodReportLines.length; i++) {
        this.SUMS[0] = this.SUMS[0] + this.shipMethodReportLines[i].Quantity;
        this.SUMS[1] = this.SUMS[1] + this.shipMethodReportLines[i].Delivered;
      }
      this.SUMS[3] = ((this.SUMS[1] / this.SUMS[0]) * 100).toFixed(2);
    },
    filterList2: function() {
      this.shipStatusReportLines = this.$store.state.shipping.delivery_status_report_line_items;
      for (var i = 0; i < this.shipStatusReportLines.length; i++) {
        this.SUMS2[0] = this.SUMS2[0] + this.shipStatusReportLines[i].Quantity;
      }
    },
    filterList3: function() {
      this.shipByDateReportLines = this.$store.state.shipping.delivery_bydate_report_line_items;
      for (var i = 0; i < this.shipByDateReportLines.length; i++) {
        this.SUMS3[0] = this.SUMS3[0] + this.shipByDateReportLines[i].Quantity;
      }
    },
    filterListOrdersSubset: function() {
      this.filteredShippingOrders = this.$store.state.shipping.shipping_orders;
      this.filteredShippingOrders = this.filteredShippingOrders.filter(
        _so => this.FilteredPOStringArray.indexOf(_so.PONumber) > -1
      );
    },
    filterListOrders: function() {
      this.filteredShippingOrders = this.$store.state.shipping.shipping_orders;
      this.filteredShippingOrders = this.filteredShippingOrders.filter(
        ord =>
          ord.FulfillmentType.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.PONumber.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.ShipName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.ShipCompany.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.ShipStatus.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.FulfillmentType.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    ResetTotals: function() {
      (this.SUMS = [0, 0, 0, 0]),
        (this.SUMS2 = [0, 0, 0, 0]),
        (this.SUMS3 = [0]);
    },
    changeMonth() {
      this.ResetTotals();
      this.$store
        .dispatch("shipping/loadDeliveryReportLineItems", this.myCurrentMonth)
        .then(() => {
          this.filterList();
        });
      this.$store
        .dispatch(
          "shipping/loadDeliveryStatusReportLineItems",
          this.myCurrentMonth
        )
        .then(() => {
          this.filterList2();
        });
      this.$store
        .dispatch(
          "shipping/loadDeliveryByDateReportLineItems",
          this.myCurrentMonth
        )
        .then(() => {
          this.filterList3();
        });
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
